module.exports = "<main>\n    <header (onProjectsListClicked)=\"onProjectsListClicked()\" [selectedProject]=\"selectedProject\"></header>\n    <projects-list *ngIf=\"!selectedProject\" [projects]=\"projects\" (onProjectSelected)=\"onProjectSelected($event)\"></projects-list>\n    <project-detail *ngIf=\"selectedProject\" [project]=\"selectedProject\" [devMode]=\"selectedDevMode\"></project-detail>\n    <error></error>\n</main>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.html
 ** module id = 810
 ** module chunks = 0
 **/